import { DEFAULT_PAGE_SIZE } from '../constants/index'

export const computeOffset = (pageIndex, pageSize) => {
  return (
    ((pageIndex ? pageIndex : 1) - 1) * (pageSize ? pageSize : DEFAULT_PAGE_SIZE)
  )
}
